<template>
  <div v-if="event && event.type === 'block'">
    <div
      class="vuecal__event-title"
      :class="{ 'title-add-padd': event.background && !isBlockPassed }"
      v-html="event.content"
    />

    <button
      class="block-edit-btn"
      @click="onDot(event)"
      v-if="event.background && !isBlockPassed"
    >
      עריכה
    </button>
    <div
      class="open-nav-dots"
      v-if="event.background && event.bg_menu"
      v-click-outside="ev => hideEditBlock(event, ev)"
    >
      <div
        class="row flex flex--end block_action"
        @click="$emit('editBlock', event)"
      >
        <span>עדכון שעות הבלוק</span><Clock />
      </div>
      <div
        class="row flex flex--end block_action"
        @click="$emit('deleteBlock', event)"
      >
        <span>מחיקת בלוק מרפאה</span><Trash />
      </div>
      <div
        class="row flex flex--end block_action"
        @click="$emit('disableBlock', event)"
        v-if="!event.is_private"
      >
        <span>חסום זימון דיגיטלי</span><Blocked />
      </div>
      <div
        class="row flex flex--end block_action"
        @click="$emit('activateBlock', event)"
        v-else
      >
        <span>הפעל זימון דיגיטלי</span><Blocked />
      </div>
    </div>
  </div>
</template>

<script>
import { isDatePassed } from "../../../utilities/dates.js";
import ClickOutside from "vue-click-outside";
import Clock from "@/assets/img/svg/clock1.svg";
import Trash from "@/assets/img/svg/trash-black.svg";
import Blocked from "@/assets/img/svg/blocked.svg";

export default {
  name: "BlockViewEvent",
  components: { Clock, Trash, Blocked },
  props: {
    event: {
      required: true
    }
  },
  directives: {
    ClickOutside
  },
  computed: {
    isBlockPassed() {
      return this.isDatePassed(this.event.start);
    }
  },
  methods: {
    isDatePassed,
    onDot(ev) {
      ev.bg_menu = !ev.bg_menu;
    },
    hideEditBlock(ev, event) {
      if (event.target.className.includes("block-edit-btn")) return;
      ev.bg_menu = !ev.bg_menu;
    }
  }
};
</script>
